export class ValidatorUtil {
    public static isEmail(email: string): boolean {
        if (typeof email !== 'string') {
            return false;
        }

        return (new RegExp('^[a-zA-Z0-9\\.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$', 'i')).test(email);
    }

    public static isPhone(phone: string): boolean {
        if (typeof phone !== 'string') {
            return false;
        }

        return (new RegExp('^([\+\\s0-9]{10,}(#[0-9]+)?)$')).test(phone);
    }

    public static isIntMobilePhone(phone: string): boolean {
        const caRegex: RegExp = new RegExp('^\\+1[0-9]{10}$', 'i');
        const frRegex: RegExp = new RegExp('^\\+33(6|7)[0-9]{8}$', 'i');
        const usRegex: RegExp = new RegExp('^\\+1[0-9]{10}$', 'i');

        return caRegex.test(phone) || frRegex.test(phone) || usRegex.test(phone);
    }

    public static isNumber(num: string | number): boolean {
        if (typeof num === 'number') {
            return true;
        }

        if (typeof num !== 'string') {
            return false;
        }

        return (new RegExp('^\-?[0-9]+\\.?[0-9]*$')).test(num);
    }

    public static isISODate(str: string): boolean {
        const strictISORegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?([+-]\d{2}:\d{2}|Z)$/;

        if (!strictISORegex.test(str)) {
            return false;
        }
        
        return !isNaN((new Date(str)).getTime());
    }
}
